/* 56px controls: the Bend Creator runs on shop tablets used in gloves. */
.stepper {
  display: flex;
  height: 56px;
  background: var(--mantine-color-white);
  border: 1px solid var(--mantine-color-gray-4);
  border-radius: 8px;
  overflow: hidden;

  &[data-error] {
    border-color: var(--mantine-color-error);
  }

  &[data-disabled] {
    background: var(--mantine-color-gray-0);
  }

  /* A fixed width: sized from its content, WebKit counts the input's default width and the + side overruns. */
  &[data-compact] {
    height: 40px;
    width: 122px;
  }
}

.stepButton {
  flex: 0 0 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: var(--mantine-color-gray-9);
  touch-action: manipulation;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:active:not(:disabled) {
    background: #f6f7f8;
  }

  &:disabled {
    color: var(--mantine-color-gray-4);
    cursor: default;
  }
}

.field {
  flex: 1;
  /* A percentage width gives the input no min-content width, so it can't push the stepper wider than its parent. */
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0 4px;
  border: 0;
  border-left: 1px solid var(--mantine-color-gray-2);
  border-right: 1px solid var(--mantine-color-gray-2);
  background: transparent;
  outline: none;
  text-align: center;
  font-family: var(--mantine-font-family-monospace);
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.5px;
  color: var(--mantine-color-gray-9);
  font-variant-numeric: tabular-nums;

  &:focus {
    box-shadow: inset 0 0 0 2px var(--mantine-primary-color-filled);
  }

  &:disabled,
  &:read-only {
    color: var(--mantine-color-gray-6);
  }

  /* Placeholders are hints, not values: the regular text font at a quieter size. */
  &::placeholder {
    font-family: var(--mantine-font-family);
    font-size: 16px;
    font-weight: 400;
    letter-spacing: normal;
    color: var(--mantine-color-placeholder);
  }
}

[data-compact] > .stepButton {
  flex-basis: 36px;
  font-size: 20px;
}

[data-compact] > .field {
  flex: 0 0 48px;
  font-size: 14px;
}
